import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function MobileOffcanvasMenu({ show, handleClose, categories = { India: [], International: [], Weekend: [], More: [] } }) {
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleDropdownToggle = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  return (
    <div className={`offcanvas offcanvas-end${show ? ' show' : ''}`} tabIndex="-1" style={{ visibility: show ? 'visible' : 'hidden' }}>
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">Menu</h5>
        <button type="button" className="btn-close text-reset" onClick={handleClose}></button>
      </div>
      <div className="offcanvas-body">
        <ul className="list-unstyled">
          {/* Trending Destinations */}
          <li>
            <button
              className={`btn w-100 text-start d-flex justify-content-between align-items-center${openDropdown === 'trending' ? ' fw-bold' : ''}`}
              onClick={() => handleDropdownToggle('trending')}
            >
              <span>
                Trending Destinations <span className="badge bg-warning text-dark ms-2">New</span>
              </span>
              <i
                className={`fas fa-chevron-down ms-2 transition-transform${openDropdown === 'trending' ? ' rotate-180' : ''}`}
                style={{
                  transition: 'transform 0.2s',
                  transform: openDropdown === 'trending' ? 'rotate(180deg)' : 'rotate(0deg)'
                }}
              ></i>
            </button>
            {openDropdown === 'trending' && (
              <ul className="list-unstyled ms-3 bg-light rounded py-2 px-1">
                <li>
                  <Link className="dropdown-item text-start" to="/destinations?location=trending-india" onClick={handleClose}>
                    India
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item text-start" to="/destinations?location=trending-international" onClick={handleClose}>
                    International
                  </Link>
                </li>
              </ul>
            )}
          </li>
          {/* India Dropdown */}
          <li>
            <button
              className={`btn w-100 text-start d-flex justify-content-between align-items-center${openDropdown === 'india' ? ' fw-bold' : ''}`}
              onClick={() => handleDropdownToggle('india')}
            >
              <span>India</span>
              <i
                className={`fas fa-chevron-down ms-2 transition-transform${openDropdown === 'india' ? ' rotate-180' : ''}`}
                style={{
                  transition: 'transform 0.2s',
                  transform: openDropdown === 'india' ? 'rotate(180deg)' : 'rotate(0deg)'
                }}
              ></i>
            </button>
            {openDropdown === 'india' && (
              <ul className="list-unstyled ms-3 bg-light rounded py-2 px-1">
                {categories.India && categories.India.length > 0 ? (
                  categories.India.map((name, idx) => (
                    <li key={name + idx}>
                      <Link
                        className="dropdown-item text-start"
                        to={`/destinations?location=${encodeURIComponent(name)}`}
                        onClick={handleClose}
                      >
                        {name}
                      </Link>
                    </li>
                  ))
                ) : (
                  <li><span className="dropdown-item text-muted">No options</span></li>
                )}
              </ul>
            )}
          </li>
          {/* International Dropdown */}
          <li>
            <button
              className={`btn w-100 text-start d-flex justify-content-between align-items-center${openDropdown === 'international' ? ' fw-bold' : ''}`}
              onClick={() => handleDropdownToggle('international')}
            >
              <span>International</span>
              <i
                className={`fas fa-chevron-down ms-2 transition-transform${openDropdown === 'international' ? ' rotate-180' : ''}`}
                style={{
                  transition: 'transform 0.2s',
                  transform: openDropdown === 'international' ? 'rotate(180deg)' : 'rotate(0deg)'
                }}
              ></i>
            </button>
            {openDropdown === 'international' && (
              <ul className="list-unstyled ms-3 bg-light rounded py-2 px-1">
                {categories.International && categories.International.length > 0 ? (
                  categories.International.map((name, idx) => (
                    <li key={name + idx}>
                      <Link
                        className="dropdown-item text-start"
                        to={`/destinations?location=${encodeURIComponent(name)}`}
                        onClick={handleClose}
                      >
                        {name}
                      </Link>
                    </li>
                  ))
                ) : (
                  <li><span className="dropdown-item text-muted">No options</span></li>
                )}
              </ul>
            )}
          </li>
          {/* Weekend Trips */}
          <li>
            <button
              className={`btn w-100 text-start d-flex justify-content-between align-items-center${openDropdown === 'weekend' ? ' fw-bold' : ''}`}
              onClick={() => handleDropdownToggle('weekend')}
            >
              <span>Weekend Trips</span>
              <i
                className={`fas fa-chevron-down ms-2 transition-transform${openDropdown === 'weekend' ? ' rotate-180' : ''}`}
                style={{
                  transition: 'transform 0.2s',
                  transform: openDropdown === 'weekend' ? 'rotate(180deg)' : 'rotate(0deg)'
                }}
              ></i>
            </button>
            {openDropdown === 'weekend' && (
              <ul className="list-unstyled ms-3 bg-light rounded py-2 px-1">
                {categories.Weekend && categories.Weekend.length > 0 ? (
                  categories.Weekend.map((name, idx) => (
                    <li key={name + idx}>
                      <Link
                        className="dropdown-item text-start"
                        to={`/destinations?location=${encodeURIComponent(name)}`}
                        onClick={handleClose}
                      >
                        {name}
                      </Link>
                    </li>
                  ))
                ) : (
                  <li><span className="dropdown-item text-muted">No options</span></li>
                )}
              </ul>
            )}
          </li>
          {/* More */}
          <li>
            <button
              className={`btn w-100 text-start d-flex justify-content-between align-items-center${openDropdown === 'more' ? ' fw-bold' : ''}`}
              onClick={() => handleDropdownToggle('more')}
            >
              <span>More</span>
              <i
                className={`fas fa-chevron-down ms-2 transition-transform${openDropdown === 'more' ? ' rotate-180' : ''}`}
                style={{
                  transition: 'transform 0.2s',
                  transform: openDropdown === 'more' ? 'rotate(180deg)' : 'rotate(0deg)'
                }}
              ></i>
            </button>
            {openDropdown === 'more' && (
              <ul className="list-unstyled ms-3 bg-light rounded py-2 px-1">
                {categories.More && categories.More.length > 0 ? (
                  categories.More.map((name, idx) => (
                    <li key={name + idx}>
                      <Link
                        className="dropdown-item text-start"
                        to={`/destinations?location=${encodeURIComponent(name)}`}
                        onClick={handleClose}
                      >
                        {name}
                      </Link>
                    </li>
                  ))
                ) : (
                  <li><span className="dropdown-item text-muted">No options</span></li>
                )}
              </ul>
            )}
          </li>
          {/* Admin Link */}
          <li className="mt-3">
            <Link
              to="/admin"
              className="btn btn-primary w-100 text-start"
              style={{ backgroundColor: '#FFA500', borderColor: '#FFA500', fontWeight: 'bold' }}
              onClick={handleClose}
            >
              Admin
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default MobileOffcanvasMenu;
